/**
 * 首页精品服务
 */

import { Row, Col, Divider, ConfigProvider } from 'antd';

import {
    DeploymentUnitOutlined,
    CustomerServiceOutlined,
    AimOutlined,
    DatabaseOutlined,
} from '@ant-design/icons';


const Premium = () => {
    return <>
        <Row>
            <Col offset={4} span={4} style={{ paddingRight: '5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><DeploymentUnitOutlined /></div>
                    <h2>项目运维服务</h2>
                    <p>根据客户需求定制服务级别协议，对企业或组织内部的信息系统进行日常维护和管理。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                    <p>【软硬件】</p>
                    <p>【稳定性】</p>
                    <p>【安全性】</p>
                    <p>【高效性】</p>
                </div>
            </Col>
            <Col span={4} style={{ padding: '0 5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><CustomerServiceOutlined /></div>
                    <h2>技术咨询服务</h2>
                    <p>为客户提供专业的信息技术咨询服务，帮助客户制定和实施信息化战略。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                    <p>【业务流程】</p>
                    <p>【系统架构】</p>
                </div>
            </Col>
            <Col span={4} style={{ padding: '0 5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><AimOutlined /></div>
                    <h2>系统集成服务</h2>
                    <p>根据客户需求，设计、开发和实施定制化的信息系统，实现信息化、智能化转型。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                    <p>【定制化软件信息系统】</p>
                    <p>【门户网站】</p>
                    <p>【小程序】</p>
                </div>
            </Col>
            <Col span={4} style={{ paddingLeft: '5px' }}>
                <div className='premium-box'>
                    <div className='box-icon'><DatabaseOutlined /></div>
                    <h2>机房运维服务</h2>
                    <p>对机房数据中心设施、设备和运行软件进行管理、维护和监控。</p>
                    <ConfigProvider
                        theme={{
                            components: {
                                Divider: {
                                    colorSplit: '#F3F3F3',
                                },
                            },
                        }}
                        ><Divider />
                    </ConfigProvider>
                    <p>【安全评估】</p>
                    <p>【漏洞扫描】</p>
                    <p>【风险管理】</p>
                </div>
            </Col>
        </Row>
    </>
}

export default Premium;